/**
 * 出口文件
 */
let baseApi = {}
// baseApi.func = function(){
// 	// TODO
// }

let apis = {}
// 扫描全部api文件
const apiFiles = require.context(
  // 其api目录的相对路径
  './modules',
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /[\w-]+\.js$/
)
// 获取文件内容
apiFiles.keys().forEach(fileName => {
  // 获取组件配置
  const api = apiFiles(fileName)
  // 剥去文件名开头的 `./` 和结尾的扩展名
  const apiName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
  if (apiName == 'index') return
  console.log('api:', api)
  Object.keys(api).forEach(item => {
    // console.log('item',item);
    apis[item] = api[item]
  })
})

let hbApis = Object.assign(baseApi, apis)
console.log('hbApis', hbApis)
let hb = Object.create(null)
hb = new Proxy(
  {},
  {
    get: function(target, name) {
      // console.log('aaaaaaaaa',target);
      // console.log('bbbbbbbbbb',name);
      if (hbApis[name]) {
        return hbApis[name]
      } else {
        return target[name]
      }
    },
    set(target, name, value) {
      target[name] = value
      return true
    }
  }
)
// if (typeof global !== 'undefined') {
//     global.hb = hb
// }

Object.defineProperty(Object.prototype, 'hb', {
  value: hb,
  writable: false
})



// WEBPACK FOOTER //
// ./src/global/index.js